module.exports = __webpack_public_path__ + "static/img/15.7918de2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/5/sp/15.png
// module id = O2z2
// module chunks = 0